import { Map, Record } from 'immutable'
import _ from 'lodash'

import { SHOW_LOADER, HIDE_LOADER } from './constants'

const LoaderRecord = Record({
    isLoading: false,
    text: '',
})

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case SHOW_LOADER: {
            const id = _.get(action, 'data.id', null)
            if (id === null) return state

            return state.set(
                id,
                new LoaderRecord({
                    isLoading: true,
                    text: action.data.text,
                })
            )
        }
        case HIDE_LOADER: {
            const id = _.get(action, 'data.id', null)

            return state.delete(id)
        }
        default:
            return state
    }
}
